import { useEffect, useState } from "react";
import { useHttpRequest } from "../../hooks/useHttpRequest";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import VoiceElements from "./VoiceElements";
import { setOnCall } from "../../app/userState/userStateSlice";
import ringtone from "../../../public/sound/ringtone.mp3";
import useSound from "use-sound";
import { useNavigate } from "react-router-dom";
import { setBotCallTranscript } from "../../app/call/callSlice";

const MainPlugin = () => {
    const { incomingMessage, callState, mediaServerMap } = useAppSelector((state) => state.call);
    const { user } = useAppSelector((state) => state.auth);
    const [meetingStatus, setMeetingStatus] = useState("");
    const [customerName] = useState("");
    const { sendRequest } = useHttpRequest();
    const dispatch = useAppDispatch()
    const [mediaUrl, setMediaUrl] = useState(process.env.REACT_APP_WSDASH_ADDRESS as string)
    const [play, { stop }] = useSound(ringtone);
    const createRoom = async () => {
        console.log('createRoom()');
        if (user && incomingMessage.username !== "" && incomingMessage.username) {

            dispatch(setOnCall("Receive SIP Call"))
            const baseUrl = String(process.env.REACT_APP_CHAT_SERVICE);
            const payload = {
                deviceId: user.deviceId,
                userName: incomingMessage.username + "_SIP",
                fullName: incomingMessage.username,
                serviceGroupId: incomingMessage.service_group_id,
                tag: "generic",
                agentUserName: user.username,
                tenantId: user.tenantId,
                channel: "ARSISIP",
                sessionId: incomingMessage.session_id,
                channelApplicationId: incomingMessage.channel_application_id
            }
            console.log('createRoom() payload', payload)
            await sendRequest({
                baseUrl: baseUrl,
                url: `/chat/JoinRoomAll`,
                method: "post",
                body: payload,

            });
        }

    }

    const loadBotCallTranscript = async () => {
        console.log('loadBotCallTranscript()');
        if (user && incomingMessage.call_id) {
            dispatch(setOnCall("Receive SIP Call"))
            const baseUrl = String(process.env.REACT_APP_CALLNOTIFICATION_SERVICE);
            console.log('loadBotCallTranscript() payload', incomingMessage.call_id)
            const result = await sendRequest({
                baseUrl: baseUrl,
                url: `/callnotification/bot-call-transcript`,
                method: "get",
                params: {
                    call_id: incomingMessage.call_id
                }
            });
            const data = result.data;
            dispatch(setBotCallTranscript(data ?? []));
        }

    }

    const navigate = useNavigate();

    const checkIsIncomingCall = () => {
        const path = window.location.pathname;

        if (!path.includes("leads") && (incomingMessage.service_group_id ?? 0) == 0) {
            navigate("/leads")
        }
        console.log("ve-pluggin showing answer screen")
        setMediaUrl(`${incomingMessage.domain}:1338`.replace('https', 'wss'));
        setMeetingStatus(`waiting-voice-sip`)
        createRoom().catch((ex) => { console.log("error", ex) })
        loadBotCallTranscript().catch((ex) => { console.log("error", ex) })
    }

    useEffect(() => {
        console.log("ve-pluggin incoming-message", meetingStatus, callState.isCalling, incomingMessage)
        if (user) {
            if (incomingMessage?.call_id !== undefined) {
                if (!callState.isCalling && (meetingStatus === "" || meetingStatus.includes("missing") || meetingStatus === "close")) {
                    if (incomingMessage.msg_type === "INCOMINGCALL") {
                        checkIsIncomingCall();
                    }
                }
                else
                    if (incomingMessage.msg_type === "INCOMINGCALL") {
                        console.log("ve-pluggin showing call screen")
                        setMediaUrl(`${incomingMessage.domain}:1338`.replace('https', 'wss'));
                        setMeetingStatus(`meeting-voice-sip`)
                    }

                if (incomingMessage.msg_type === "CANCELEDCALL")
                    stop()
            }
        }
    }, [incomingMessage])

    useEffect(() => {
        console.log("callState Index ve-pluggin", callState, incomingMessage);
        if (callState.isCalling && incomingMessage.call_id === undefined) {
            console.log('ve-pluggin show call screen from callstate');
            setMeetingStatus(`meeting-voice-sip`)
            if (mediaServerMap.length > 0) {
                const selectedMediaServer = mediaServerMap.filter(x => x.lastnumber == callState.callDestination.slice(-1))
                if (selectedMediaServer.length > 0) {
                    setMediaUrl(`wss://${selectedMediaServer[0].url}:1338`)
                }
            }
        }
    }, [callState])
    useEffect(() => {
        if (meetingStatus.includes("waiting"))
            play()
        else if (meetingStatus.includes("missing") || meetingStatus.includes("meeting"))
            stop()

        console.log('MEETINGSTATUS>>>', meetingStatus);
    }, [meetingStatus])
    useEffect(() => {
        loadBotCallTranscript().catch(e => console.log(e));
    }, [user])
    return (
        <>
            {(meetingStatus.includes("waiting") || meetingStatus.includes("missing") || meetingStatus.includes("meeting")) &&
                <VoiceElements mediaUrl={mediaUrl} meetingStatus={meetingStatus} customerName={customerName} setMeetingStatus={(status) => {
                    setMeetingStatus(status)
                }}></VoiceElements>
            }
        </>
    );
}

export default MainPlugin;
